<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  startDate: {
    type: String,
    required: true,
  },
  endDate: {
    type: String,
    required: true,
  },
  fromTime: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

const formatDate = dateString => {
  if (!dateString) return '';
  const date = new Date(dateString + 'T00:00:00');
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
</script>

<template>
  <div
    class="bg-gradient-to-br from-n-blue-1 to-n-blue-2 dark:from-n-blue-12 dark:to-n-blue-11 rounded-xl p-4 border border-n-blue-4 dark:border-n-blue-9"
  >
    <div class="flex items-start justify-between mb-4">
      <div>
        <h3
          class="text-lg font-semibold text-n-blue-11 dark:text-n-blue-2 mb-1"
        >
          {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.LIMIT.SUMMARY_TITLE') }}
        </h3>
        <p class="text-sm text-n-blue-10 dark:text-n-blue-4">
          {{
            t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.LIMIT.DATE_RANGE', {
              start: formatDate(startDate),
              end: formatDate(endDate),
            })
          }}
        </p>
      </div>
      <div
        class="w-12 h-12 bg-n-blue-9 dark:bg-n-blue-6 rounded-full flex items-center justify-center"
      >
        <svg
          class="w-6 h-6 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
    </div>

    <div class="text-2xl font-bold text-n-blue-11 dark:text-n-blue-2 mb-1">
      {{ fromTime }}
    </div>
    <div class="text-sm text-n-blue-10 dark:text-n-blue-4">
      {{ t('CAMPAIGN.WHATSAPP_OFFICIAL.ADD_SCHEDULE.LIMIT.SEND_TIME_LABEL') }}
    </div>
  </div>
</template>
